
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as echarts from "echarts";

export interface LineDataType {
  lineName: string;
  xData: any[];
  // yData: any[];
  yData: any;
  legendList: any[];
  type: number;
  from: 'real';
}

// const xData = [90, 60, 6, 9];
// const yData = [160, 120, 16, 20];
// const lineName = "";

@Component
export class StackedAreaChart extends Vue {
  @Prop({ default: () => ({ xData:[], yData: {}, lineName: '', legendList: ["中奖数", "抽奖数"], type: 1, from: 'real' }) }) params!: LineDataType;
  @Prop({ default: false }) simple!: boolean;

  chart: any = null;
  legendColorList = ["#1A5EF9", "#21CCFF"];

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  mounted() {
    this.chart = echarts.init(this.$refs.StackedBarChartRef as HTMLElement);
    this.getData();
  }

  getData() {
    this.chart.setOption(this.normalOption());
  }

  getYAxisConfig() {
    // 1. 取出所有数据，计算最大值
    const { topData = [], bottomData = [] } = this.params.yData;
    const allData = [...topData, ...bottomData].filter(item => !isNaN(item));
    if (allData.length === 0) return { max: 10, interval: 2 };
    const maxValue = Math.max(...allData);
    // 2. 按规则返回配置
    if (maxValue <= 10) {
      return { max: 10, interval: 2 };
    } else if (maxValue < 100) {
      return { max: 100, interval: 20 };
    } else {
      // 大于等于100：向上取整到50的倍数，interval=50
      const dynamicMax = Math.ceil(maxValue / 50) * 50;
      return { max: dynamicMax, interval: 50 };
    }
  }


  normalOption() {
    // 获取动态Y轴配置
    const { max, interval } = this.getYAxisConfig();
    return {
      title: {
        // text: this.params.lineName,
        // left: 'center',
        // textStyle: {
        //   fontSize: 14,
        //   fontWeight: 'normal'
        // }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        formatter: (params: any) => {
          console.log("tooltip params ---", params);
          
          const category = params[0].name;
          let drawn = 0;    // 已抽奖
          let remain = 0;   // 剩余可抽奖

          params.forEach((p: any) => {
            if (p.seriesIndex === 1) {
              drawn = p.value || 0;
            }
            if (p.seriesIndex === 0) {
              remain = p.value || 0;
            }
          });

          // 总可抽奖 = 已抽奖 + 剩余可抽奖
          // const drawable = drawn + remain;

          return  this.params. from ===  'real' ? `
            <div style="text-align: left;">
              <div>${category}</div>
              <div>中奖数次数：${drawn}${this.params.type === 1 ? '人' : '次'}</div>
              <div>抽奖数次数：${remain}${this.params.type === 1 ? '人' : '次'}</div>
            </div>
          ` : this.params. from ===  'during' ? `
            <div style="text-align: left;">
              <div>${category}</div>
              <div>可抽奖会员消费额：${drawn}</div>
              <div>兑奖会员消费额：${remain}</div>
            </div>
          ` : `
            <div style="text-align: left;">
              <div>${category}</div>
              <div>可抽奖会员消费额：${remain}</div>
              <div>兑奖会员消费额：${drawn}</div>
            </div>
          `;
        },
      },
      legend: {
        data: this.params.legendList,
        bottom: 0,
        icon: 'circle'
      },
      grid: {
        left: 15,      // 增加左侧边距
        right: 15,     // 增加右侧边距
        top: 30,
        bottom: 10,    // 增加底部边距，避免X轴文字被遮挡
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: ['1%', '1%'], // 左右各留5%的空白，标签不会贴边
        // boundaryGap: true,
        // data: ['12月1日', '12月2日', '12月3日', '12月4日', '12月5日', '12月6日', '12月7日'],
        data: this.params.xData,
        axisLine: {
          lineStyle: {
            color: '#C9CDD4',
            fontSize: 12
          },
        },
        // 移除X轴刻度
        axisTick: {
          show: false
        },
        axisLabel: {
          fontSize: 12,
          color: "#4E5969",
          interval: 'auto',       // 强制显示所有X轴标签 0  显示单 1  显示双 2
          // rotate: 10,        // 文字旋转15度，减少横向占用空间
          // rotate: 0,
          margin: 8          // 增加文字与轴线的间距
        }
      },
      yAxis: {
        type: 'value',
        // min: 0,
        // max: 250, // Y轴最大值
        // max: this.params.yData[this.params.yData.length - 1],
        // interval: 50,
        min: 0,
        max: max,
        interval: interval,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#e0e0e0'
          }
        },
        axisLabel: {
          fontSize: 12,
          color: "#4E5969"
        }
      },
      series: [
        {
          // name: this.params.legendList[0] || '中奖数',
          type: 'line',
          smooth: false, // 取消平滑效果
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: '#40c9ff',
            borderColor: '#fff',
            borderWidth: 2
          },
          lineStyle: {
            width: 2,
            color: '#40c9ff'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(22, 119, 255, 0.3)' },
              { offset: 1, color: 'rgba(22, 119, 255, 0.05)' }
            ])
          },
          // data: [60, 135, 102, 200, 88, 240, 135]
          data: this.params.yData.topData
        },
        {
          // name: this.params.legendList[1] || '抽奖数',
          type: 'line',
          smooth: false, // 取消平滑效果
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: '#1677ff',
            borderColor: '#fff',
            borderWidth: 2
          },
          lineStyle: {
            width: 2,
            color: '#1677ff'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(64, 201, 255, 0.2)' },
              { offset: 1, color: 'rgba(64, 201, 255, 0.02)' }
            ])
          },
          // data: [40, 58, 50, 72, 45, 82, 60]
          data: this.params.yData.bottomData
        }
      ]
    };
  }
}

export default StackedAreaChart;
